import React from "react";
import { Button, Icon, Menu, MenuItem } from "@nike/eds";
import { UserInfo } from "../models/IUserDetails"
import { FC, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { CaretDown, CaretUp } from "@nike/nike-design-system-icons";
import { useSponsorContext } from "../context/Sponsor";

export type Props = {
    userInfo: UserInfo | undefined;
};

export const Profile: FC<Props> = ({ userInfo }) => {

    const [logoutMenuAnchor, setLogoutMenuAnchor] = useState<null | HTMLElement>(null);
    const isLougoutMenuOpen = Boolean(logoutMenuAnchor);

    const handleOpenLogoutMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        isLougoutMenuOpen ?  setLogoutMenuAnchor(null):setLogoutMenuAnchor(event.currentTarget);
    };
    const handleCloseLogoutMenu = () => {
        setLogoutMenuAnchor(null);
    };
    const {sponsor} = useSponsorContext();
    const { oktaAuth } = useOktaAuth();
    const handleIdleLogout = () => {
         oktaAuth.signOut();
    }
    const body = (
        <>
            <div>
                <MenuItem onClick={() => {
                     handleIdleLogout();
                }}>Sign Out</MenuItem>
            </div>
        </>)
    return userInfo?.passplayUser ? (<div className="eds-flex eds-flex--align-items-center">
        <Menu
        bodySlot={body}
        placement={"bottom-start"}
        isOpen={isLougoutMenuOpen}
        onClickOutside={() => {  handleCloseLogoutMenu() }}
        id="logout-menu"
        >
            <Button
             afterSlot={isLougoutMenuOpen ? <CaretUp /> : <CaretDown />}
             variant="ghost"
             onClick={handleOpenLogoutMenu}
             aria-expanded={isLougoutMenuOpen ? 'true' : undefined}
             aria-haspopup='true'
             aria-controls='logout-menu'
             size="small">
                <Icon
                    name="Profile"
                    size="s"
                    backgroundShape="circle"
                    color="white"
                    backgroundColor="var(--eds-color-grey-2)"
                    enableFocus />
                { !!sponsor && 
                   <span className="eds-spacing--m-4 span-10">{`${sponsor?.displayName}, ${sponsor?.externalId}`}</span>
                }
            </Button>
        </Menu>
    </div>
    ) : null;
}